import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ApplicationContent from "./ApplicationContent";
import applicationNavigation from "constants/navigation/applicationNavigation";

function Application({ title }) {
	// Init hooks
	const { t } = useTranslation();

	// Init params
	const { id } = useParams();

	// Init state
	const [is404, setIs404] = useState(false);
	const navigation = applicationNavigation(id);

	// Rendering application content with Navbar. Otherwise, 404 error
	if (is404 === false) {
		return (
			<ApplicationContent
				navigation={navigation}
				id={id}
				setIs404={setIs404}
				title={title}
			/>
		);
	} else {
		return <p>{t("message.applicationIdNotExist", { id })}</p>;
	}
}

export default Application;
